import React from "react";

import Form from "antd/es/form";
import { useWatch } from "antd/es/form/Form";
import { defineMessages, useIntl } from "react-intl";

import Checkbox from "@app/component/input/Checkbox";
import DefaultPreferencesFormComponent from "@app/scene/dashboard/components/cards/common/DefaultPreferencesFormComponent";
import Scoped from "@app/scene/dashboard/types/Scoped";

import styles from "./PreferencesFormComponent.module.scss";

const messages = defineMessages({
  sectionTitle: {
    id: "dashboard.editModal.criteria.checkIns.extraOptions",
    defaultMessage: "Show unique chart lines for:",
    description:
      "Title of the extra settings section in preferences form in Edit Check-Ins Modal on Dashboard",
  },
  showTotal: {
    id: "dashboard.editModal.criteria.checkIns.shotTotal",
    defaultMessage: "Total count",
    description:
      "Show total count checkbox label in preferences form in Edit Check-Ins Modal on Dashboard",
  },
  showUnverified: {
    id: "dashboard.editModal.criteria.checkIns.showUnverified",
    defaultMessage: "Un-verified Check-ins",
    description:
      "Show un-verified check-ins checkbox label in preferences form in Edit Check-Ins Modal on Dashboard",
  },
  showVerified: {
    id: "dashboard.editModal.criteria.checkIns.showVerified",
    defaultMessage: "Verified Check-ins",
    description:
      "Show verified check-ins checkbox label in preferences form in Edit Check-Ins Modal on Dashboard",
  },
});

interface Props extends Scoped {}

const PreferencesFormComponent: React.FC<Props> = ({ scope }) => {
  const intl = useIntl();

  const showChart = useWatch(["preferences", "showChart"]);
  const includeUnverified = useWatch(["criteria", "includeUnverified"]);

  return (
    <DefaultPreferencesFormComponent
      extraChartPreferences={
        <div
          className={styles.extraChartPreferences}
          style={{ display: showChart ? "initial" : "none" }}
        >
          <span className={styles.title}>{intl.formatMessage(messages.sectionTitle)}</span>
          <div>
            <Form.Item name={["preferences", "showTotal"]} noStyle preserve valuePropName="checked">
              <Checkbox disabled={!includeUnverified}>
                {intl.formatMessage(messages.showTotal)}
              </Checkbox>
            </Form.Item>
          </div>
          <div>
            <Form.Item
              name={["preferences", "showVerified"]}
              noStyle
              preserve
              valuePropName="checked"
            >
              <Checkbox>{intl.formatMessage(messages.showVerified)}</Checkbox>
            </Form.Item>
          </div>
          <div>
            <Form.Item
              name={["preferences", "showUnverified"]}
              noStyle
              preserve
              valuePropName="checked"
            >
              <Checkbox disabled={!includeUnverified}>
                {intl.formatMessage(messages.showUnverified)}
              </Checkbox>
            </Form.Item>
          </div>
        </div>
      }
      scope={scope}
      showVerifiedBreakdown
    />
  );
};

export default PreferencesFormComponent;
